import React, { ComponentProps } from 'react';
import { Checkbox, Modal } from 'antd';
import Text from 'antd/lib/typography/Text';

type CustomProps = {
  workersCount: number;
  onConfirm: () => void;
  setInviteWorkers: (value: boolean) => void;
};

type Props = CustomProps & ComponentProps<typeof Modal>;

export function WorkerUploadConfirmModal({
  onConfirm,
  workersCount,
  setInviteWorkers,
  ...props
}: Props) {
  const isPlural = workersCount > 1;

  return (
    <>
      <Modal
        className="workers-update-modal"
        title={`Confirm adding ${workersCount} staff member${
          isPlural ? 's' : ''
        }`}
        cancelText="Cancel"
        okText="Confirm"
        onOk={onConfirm}
        {...props}
      >
        <Text>This action cannot be undone.</Text>
        <Checkbox
          style={{ marginTop: 16 }}
          onChange={(e) => setInviteWorkers(e.target.checked)}
        >
          Send invite to the new staff upon creation
        </Checkbox>
      </Modal>
      <style jsx>{`
        :global(.workers-update-modal .ant-modal-footer) {
          text-align: right;
        }
      `}</style>
    </>
  );
}
